<template>
  <div class="mb-8 animate-pulse bg-white-500 shadow sm:rounded-lg">
    <div class="px-4 py-5 sm:p-6">
      <div class="h-12 w-64 rounded-sm bg-neutral-100" />
      <div class="mt-2">
        <div class="w-lg h-8 rounded-sm bg-neutral-100" />
      </div>
    </div>
  </div>
</template>
